import React from "react";

import { Field } from "formik";
import indexOf from "lodash/indexOf";
import { connect } from "react-redux";

import SelectField from "../../components/SelectField";
import PercentField from "../../components/PercentField";
import MoneyTextField from "../../components/MoneyTextField";

import { MARGIN_TOP } from "../../config/constants";
import pms_loan_terms from "../../constants/pms_loan_terms";
import { BORROWER } from "../../constants/contact_id_status";
import pms_lien_position, {
  TRUST_DEED2,
  TRUST_DEED3,
} from "../../constants/pms_lien_position";

const LoanRequestFields = ({ id_status, values }) => {
  return (
    <React.Fragment>
      <Field
        name="loan_amount"
        component={MoneyTextField}
        label="Loan Amount"
        required
      />

      <Field
        name="lien_position"
        component={SelectField}
        label="Lien Position *"
        options={pms_lien_position}
        required
        formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
      />

      <Field
        name="loan_terms"
        component={SelectField}
        label="Loan Term Requested *"
        options={pms_loan_terms}
        required
        formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
      />

      <Field
        name="interest_rate"
        component={PercentField}
        label="Interest Rate Requested"
        required
        formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
      />

      {id_status !== BORROWER.value && (
        <React.Fragment>
          <Field
            name="broker_points"
            component={PercentField}
            label="Broker Points"
            required
            formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
          />

          <Field
            name="broker_processing_fee_5"
            component={MoneyTextField}
            label="Broker Processing"
            required
            formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
          />
        </React.Fragment>
      )}

      {indexOf([TRUST_DEED2.value, TRUST_DEED3.value], values.lien_position) !==
        -1 && (
        <Field
          name="1st_td_amount"
          component={MoneyTextField}
          label="1st Trust Deed Balance"
          required
          formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
        />
      )}

      {indexOf([TRUST_DEED3.value], values.lien_position) !== -1 && (
        <Field
          name="2nd_td_amount"
          component={MoneyTextField}
          label="2nd Trust Deed Balance"
          required
          formControlStyle={{ style: { marginTop: MARGIN_TOP } }}
        />
      )}
    </React.Fragment>
  );
};

const mapState = (state) => {
  return {
    id_status: state.form.contacts.id_status,
  };
};

export default connect(mapState)(LoanRequestFields);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/LoanRequestFields.js